import React from "react";
import {
  Modal,
  Text,
  Button,
  ModalBackdrop,
  ModalHeader,
  ModalTitle,
  ModalContent,
  ModalPositioner,
  ModalFooter,
} from "@commonsku/design-system";

export type DeleteConversationModalProps = Readonly<{
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}>

export function DeleteConversationModal(props: DeleteConversationModalProps) {
  const { open, onOpenChange, onConfirm } = props;

  return (
    <Modal
      open={open}
      onOpenChange={(details) => onOpenChange(details.open)}
      role="alertdialog"
      placement="center"
      size="sm"
    >
      {/* @ts-ignore */}
      <ModalBackdrop bg="rgba(0, 0, 0, 0.45)" />

      {/* @ts-ignore */}
      <ModalPositioner fontFamily="body">
        {/* @ts-ignore */}
        <ModalContent mx="4" minH="160px" w="calc(100vw - 32px)" maxW="400px" borderRadius="8px">
          <ModalHeader px="24px" pt="24px" pb="0" flexDirection="column" gap="8px">
            <ModalTitle
              className="modal-title-override"
              fontFamily="heading"
              fontSize="md"
              fontWeight="semibold"
              lineHeight="24px"
              color="text.fg"
            >
              Delete chat
            </ModalTitle>
            <Text fontSize="sm" fontWeight="normal" color="fg.default" verticalAlign="middle" lineHeight="20px">
              Are you sure you want to delete this chat?
            </Text>
          </ModalHeader>

          <ModalFooter gap="8px">
            <Button
              width="75px"
              height="36px"
              minWidth="size.9"
              variant="outline"
              bg="white"
              color="bg.default"
              borderColor="neutral.muted"
              _hover={{ bg: "neutral.subtle" }}
              onClick={() => onOpenChange(false)}
              padding="2px Spacing.3_5 2px Spacing.3_5"
              gap="spacing.2"
            >
              Cancel
            </Button>

            <Button
              width="75px"
              height="36px"
              minWidth="size.9"
              bg="red.600"
              color="white"
              _hover={{ bg: "red.700" }}
              onClick={onConfirm}
              padding="2px Spacing.3_5 2px Spacing.3_5"
              gap="spacing.2"
            >
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </ModalPositioner>
    </Modal>
  );
}
